import React from 'react';
import Base from './Base';

export default (props) => (
  <Base {...props}>
    <path d="M18.47,42.71,7.92,34.16,33.6,2.53l10.54,8.56ZM6.7,35.66,5.86,47.47l11.38-3.25" />
  </Base>
);
